// Documentation on setting up google analytics events
// https://developers.google.com/analytics/devguides/collection/ga4/events?client_type=gtag
import { __decorate } from "tslib";
import { _Memo } from '@naturalcycles/js-lib';
import { googleTag } from './googleTag.pixel';
class GoogleAnalyticsClient {
    constructor() {
        // This ID can be found in the google analytics dashboard under Admin > Property > Data Streams > Web > Measurement ID
        this.pixelId = 'G-8C30PH6DYW';
    }
    load() {
        googleTag(this.pixelId);
    }
    pageView() {
        this.load();
        globalThis.window.gtag('event', AnalyticsEvent.page_view, {
            send_to: this.pixelId,
        });
    }
    lead() {
        this.load();
        globalThis.window.gtag('event', AnalyticsEvent.lead, {
            send_to: this.pixelId,
        });
    }
    addToCart() {
        this.load();
        globalThis.window.gtag('event', AnalyticsEvent.add_to_cart, {
            send_to: this.pixelId,
        });
    }
    purchase() {
        this.load();
        globalThis.window.gtag('event', AnalyticsEvent.purchase, {
            send_to: this.pixelId,
        });
    }
    postPurchase() {
        this.load();
        globalThis.window.gtag('event', AnalyticsEvent.post_purchase, {
            send_to: this.pixelId,
        });
    }
}
__decorate([
    _Memo()
], GoogleAnalyticsClient.prototype, "load", null);
export const googleAnalyticsClient = new GoogleAnalyticsClient();
// Google analytics event name rules https://support.google.com/analytics/answer/13316687?hl=en
var AnalyticsEvent;
(function (AnalyticsEvent) {
    AnalyticsEvent["page_view"] = "page_view";
    AnalyticsEvent["lead"] = "lead";
    AnalyticsEvent["add_to_cart"] = "add_to_cart";
    AnalyticsEvent["purchase"] = "purchase";
    AnalyticsEvent["post_purchase"] = "post_purchase";
})(AnalyticsEvent || (AnalyticsEvent = {}));
